import { api, track, LightningElement } from "lwc";
import { withImageProxy } from "common/withImageProxy";
import { getAssetsUrl } from "common/helpers";
import placeholderImg from "./assets/placeholder.svg";

export default class extends LightningElement {
  @api imgSrc: string = "";
  @api percent: number | null = null;
  @track private imgSrcProxy: string = getAssetsUrl(placeholderImg);

  async connectedCallback() {
    this.imgSrcProxy = await withImageProxy(this.imgSrc);
  }

  private get d() {
    if (!this.percent) return "";
    let isLong = this.percent > 50 ? 1 : 0;
    let fill = 1 - this.percent / 100;
    let arcX = Math.cos(2 * Math.PI * fill);
    let arcY = Math.sin(2 * Math.PI * fill);
    return `M 1 0 A 1 1 0 ${isLong} 0 ${arcX} ${arcY} L 0 0`;
  }
}
